import CartItem from "./CartItem";

export default function Cart() {
  return (
    <div>
      <CartItem />
    </div>
  );
}
